import menu from '../../assets/json/main-menu.json';

document.addEventListener('DOMContentLoaded', () => {
    const mainMenuContainer = document.querySelector('#main_menu');
    if (mainMenuContainer) {
        RenderMenu(menu, mainMenuContainer);
    }

    const mobileMenuContainer = document.querySelector('#mobile_menu_container');
    if(mobileMenuContainer){
        
        RenderMenu(menu, mobileMenuContainer);
    }


    // mobile menu
    const hamburger = document.querySelector('#mobile_hamburger');
    const mobileMenu = document.querySelector('#mobile_menu');

    if(hamburger && mobileMenu){
        const mobileMenuClose = mobileMenu.querySelector('.ico--close');

        hamburger.addEventListener('click', (e) => {
            mobileMenu.classList.add('active');
        });

        if(mobileMenuClose){
            mobileMenuClose.addEventListener('click', (e) => {
                mobileMenu.classList.remove('active');
            })
        }
    }
});

const RenderMenu = (menu, location) => {
    if (location instanceof HTMLUListElement) {
        const menuItems = menu['menu-items'];

        if (!menuItems || !Array.isArray(menuItems)) {
            console.error('Invalid menu data:', menu);
            return;
        }

        const currentUrl = window.location.pathname; // Get current page URL path

        menuItems.forEach((item) => {
            const menuItem = document.createElement('li');
            menuItem.classList.add('menu-item');

            // Check if this menu item's URL matches the current page
            const isActive = currentUrl === item.url ? 'active' : '';

            menuItem.innerHTML = `<a href="${item.url}" class="${isActive}">${item.name}</a>`;
            location.appendChild(menuItem);
        });
    }
};
